import React, { useState } from "react";
import { FaPhoneAlt, FaWhatsapp, FaComments, FaTimes } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap-icons/font/bootstrap-icons.css"; // Import CSS

const FloatingContactButtons = () => {
  const [open, setOpen] = useState(false);

  const phoneNumber = "919488336599";
  const whatsappMsg = "Hi! I'm interested in knowing more about MCGANS College website and courses.";

  const openWhatsApp = () => {
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMsg)}`,
      "_blank"
    );
  };

  return (
    <div className="contact-wrapper">
      
      <div className={`button-group ${open ? "show" : ""}`}>
        
        <button className="circle-btn green" onClick={() => window.open(`tel:+${phoneNumber}`)}>
          <FaPhoneAlt size={20} />
        </button>

        <button className="circle-btn green" onClick={openWhatsApp}>
          <FaWhatsapp size={22} />
        </button>
      </div>

      <button className="circle-btn red main-btn" onClick={() => setOpen(!open)}>
        {open ? <FaTimes size={26} /> : <FaComments size={26} />}
      </button>

    </div>
  );
};

export default FloatingContactButtons;
